import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import { useForm } from 'react-hook-form';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import { useDispatch, useSelector } from 'react-redux';
import {
	AddCarAgentListing,
	AddMedia,
	getCarAgentCarListing,
} from './../../../../Redux/Actions/UserAction';
import { FilledInput } from '@material-ui/core';
import { CarAgentCommonHeader } from './CarAgentCommonHeader';
import Sidebar from '../../../common/Sidebar/Sidebar';
import LogoCropModal from '../../../common/Modal/LogoCropModal';
import Swal from 'sweetalert2';
const CarAgentsBusiness = () => {
	// [CF 2026-08-17 #11] This form never had translation wired in.
	const { t } = useTranslation();
	const {
		register,
		handleSubmit,
		setValue,
		formState: { errors },
	} = useForm({ mode: 'all' });

	const [ImageLogo, setImageLogo] = useState({
		sImage: '',
	});
	const [ImageBlob, setImageBlob] = useState({ blob: '' });
	// Cropper state: { src, name } of the just-picked image, shown in the modal.
	const [cropSrc, setCropSrc] = useState(null);
	const [cropName, setCropName] = useState('');
	// Additional phone numbers beyond the primary phone + whatsapp. Each entry is
	// { countryCode, mobileNumber }. Appended to mobileNumbers on submit.
	const [extraPhones, setExtraPhones] = useState([]);
	const addExtraPhone = () =>
		setExtraPhones(p => [...p, { countryCode: '+965', mobileNumber: '' }]);
	const removeExtraPhone = i =>
		setExtraPhones(p => p.filter((_, idx) => idx !== i));
	const updateExtraPhone = (i, key, value) =>
		setExtraPhones(p =>
			p.map((row, idx) => (idx === i ? { ...row, [key]: value } : row))
		);
	const [CarAgentsData, setCarAgentsDAta] = useState({
		carAgentName: '',
		mobileNumberCountryCode: '',
		mobileNumber: '',
		location: '',
		website: '',
		"gps": {
			"lat": "12.001",
			"long": "34.113"
		},
		socialMedia: {
			FACEBOOK: '',
			SNAPCHAT: '',
			INSTAGRAM: '',
			YOUTUBE: '',
			LINKEDIN: '',
			TWITTER: '',
		},
		mediaIds: {
			LOGO: [''],
		},
	});

	const dispatch = useDispatch();

	const home = useSelector(state => state?.home);

	const carListing = home?.CarDealerCarList;
	const getMybusiness = home?.getMybusiness;

	// The owner's business id can arrive two ways after a reload: from Redux
	// (getMybusiness) or from sessionStorage (set by the Header once
	// /business/my resolves). Refetch as soon as it's known so the form
	// repopulates instead of staying blank after creating a business.
	const ownerBid =
		(getMybusiness?.businessId && String(getMybusiness.businessId)) ||
		sessionStorage.getItem('BusinessId');
	const validBid =
		ownerBid && ownerBid !== 'undefined' && ownerBid !== 'null' && ownerBid !== '';

	useEffect(() => {
		if (validBid) {
			dispatch(getCarAgentCarListing());
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	},[ownerBid])

	console.log("carListing", carListing);

	useEffect(() => {
		if(carListing?.length > 0){
			setCarAgentsDAta({
				carAgentName: carListing?.[0]?.carAgentName,
				mobileNumberCountryCode: carListing?.[0]?.mobileNumberCountryCode,
				mobileNumber: carListing?.[0]?.mobileNumber,
				location: carListing?.[0]?.location,
				website: carListing?.[0]?.website,
				"gps": {
					"lat": "12.001",
					"long": "34.113"
				},
				// socialMedia: {
				// 	FACEBOOK: carListing?.[0]?socialMedia..carAgentName,
				// 	SNAPCHAT: carListing?.[0]?socialMedia..carAgentName,
				// 	INSTAGRAM: carListing?.[0]?socialMedia..carAgentName,
				// 	YOUTUBE: carListing?.[0]?socialMedia..carAgentName,
				// 	LINKEDIN: carListing?.[0]?socialMedia..carAgentName,
				// 	TWITTER: carListing?.[0]?socialMedia..carAgentName,
				// },
				mediaIds: {
					LOGO: [carListing?.[0]?.carMedia?.[0]?.media?.mediaId],
				},
			})

			// Sync prefilled required values into react-hook-form. The inputs are
			// controlled by state, but RHF only tracks values entered through its
			// own onChange — without this, a prefilled form would fail validation
			// on submit even though the fields are visibly filled.
			setValue('carAgentName', carListing?.[0]?.carAgentName || '', {
				shouldValidate: true,
			});
			setValue('mobileNumber', carListing?.[0]?.mobileNumber || '', {
				shouldValidate: true,
			});

			// Load any saved numbers beyond the first two (phone + whatsapp) into
			// the additional-phones editor so they show up and can be edited.
			const _savedNums = carListing?.[0]?.mobileNumbers;
			if (Array.isArray(_savedNums) && _savedNums.length > 2) {
				setExtraPhones(
					_savedNums.slice(2).map(n => ({
						countryCode: n?.countryCode || '+965',
						mobileNumber: n?.mobileNumber || '',
					}))
				);
			}
		}
	},[carListing])

	function handleChange(e) {
		const { name, value } = e.target;
		setCarAgentsDAta(user => ({ ...user, [name]: value }));
	}

	// Bridge react-hook-form registration with the controlled state updater so
	// validation runs live (as the user types) AND the controlled value stays in
	// sync — fixes the conflict where handleChange overrode RHF's onChange.
	const field = (fieldName, rules) => {
		const r = register(fieldName, rules);
		return {
			...r,
			onChange: e => {
				r.onChange(e);
				handleChange(e);
			},
		};
	};
	const mediaChange = e => {
		setCarAgentsDAta({
			...CarAgentsData,
			socialMedia: {
				...CarAgentsData.socialMedia,
				[e.target.name]: e.target.value,
			},
		});
	};
	// const imageIds = e => {
	// 	setCarAgentsDAta({
	// 		...CarAgentsData,
	// 		mediaIds: {
	// 			LOGO: e.target.value[0],
	// 		},
	// 	});
	// };

	const handleUploadImage = event => {
		const file = event.target.files[0];
		if (!file) return;

		// Validate: must be an image, and within a sane size limit
		if (!file.type || !file.type.startsWith('image/')) {
			Swal.fire({
				title: 'Invalid file',
				text: 'Please upload an image file (JPG, PNG, etc.).',
				icon: 'error',
			});
			event.target.value = '';
			return;
		}
		const MAX_MB = 12;
		if (file.size > MAX_MB * 1024 * 1024) {
			Swal.fire({
				title: 'Image too large',
				text: `Please upload an image smaller than ${MAX_MB} MB.`,
				icon: 'error',
			});
			event.target.value = '';
			return;
		}

		// Load the picked image and open the cropper modal. The owner frames the
		// logo in a square; the cropped, compressed JPEG is uploaded on Apply.
		const reader = new FileReader();
		reader.onload = ev => {
			setCropName(file.name || 'logo');
			setCropSrc(ev.target.result);
		};
		reader.readAsDataURL(file);
		// Allow re-picking the same file later.
		event.target.value = '';
	};

	// Upload a cropped square logo (called by the cropper modal's Apply button).
	const uploadCroppedLogo = result => {
		setCropSrc(null);
		if (!result || !result.file) return;
		// The preview <img> reads ImageLogo.sImage, so set that to the data URL
		// (same shape the prefill/preview uses) — otherwise the cropped image
		// won't show.
		if (result.preview) setImageLogo({ sImage: result.preview });
		const formData = new FormData();
		formData.append('media', result.file);
		// silent: the inline preview is the confirmation, so no success popup.
		pendingLogoUploadRef.current = true;
		dispatch(AddMedia({ formData, silent: true }));
	};


	const pendingLogoUploadRef = useRef(false);
	/* [CF 2026-08-11] The uploaded logo id arrives asynchronously in the effect
	   below, but other effects (the prefill and the mobileNumbers rebuild) also
	   call setState from their own stale snapshot and can drop it before submit —
	   the save then re-sends the OLD id, which the owner sees as "the logo did not
	   change". This ref is written the instant the upload resolves and applied
	   again at submit time, so it cannot be clobbered. */
	const logoIdRef = useRef(null);
	const logoid = useSelector(state => state.home.AddMediaList);
	console.log('useSelecter ', logoid);
  /* [CF 2026-08-09 #18] `home.AddMediaList` is a GLOBAL redux slot written by
     every media upload anywhere in the app, and nothing ever clears it. This
     effect therefore also fired on MOUNT, off whatever the last upload had
     left behind, silently stamping the PREVIOUS company's logo id into this
     form — save it and that company's logo came back, which is the "updating
     one company's logo reverts the other one" report. Consume the slot only
     when THIS page actually started an upload; same guard the `*Banner.js`
     screens already carry as `pendingUploadRef`. */
	useEffect(() => {
	  if (!pendingLogoUploadRef.current) return;
	  pendingLogoUploadRef.current = false;
		console.log('hellow ', logoid);
		if (logoid !== undefined) {
			const LogoId = logoid.data.response.media[0].mediaId;
			logoIdRef.current = LogoId;
			console.log('logoid', LogoId);
			// const logoid = ['ksjdkfjaslkd'];
			setCarAgentsDAta({
				...CarAgentsData,
				mediaIds: {
					...CarAgentsData.mediaIds,
					LOGO: [LogoId],
				},
			});
		}
	}, [logoid]);

	useEffect(() => {
		setCarAgentsDAta({
			...CarAgentsData,
			mobileNumbers: [
				{
					"countryCode": CarAgentsData.mobileNumberCountryCode,
					"mobileNumber": CarAgentsData.mobileNumber
				},
				{
					"countryCode": CarAgentsData.WhatsAppNumberCountryCode,
					"mobileNumber": CarAgentsData.WhatsAppNumber
				}
			]
		})
	}, [CarAgentsData.mobileNumberCountryCode,CarAgentsData.mobileNumber,CarAgentsData.WhatsAppNumberCountryCode,CarAgentsData.WhatsAppNumber])

	const datasubmit = e => {
		// Append filled-in additional phone numbers to the primary phone + whatsapp
		// entries already built in CarAgentsData.mobileNumbers.
		const _extra = extraPhones.filter(
			p => p.mobileNumber && String(p.mobileNumber).trim()
		);
		const _payload = {
			...CarAgentsData,
			mobileNumbers: [...(CarAgentsData.mobileNumbers || []), ..._extra],
		};
		if (logoIdRef.current) {
			_payload.mediaIds = {
				..._payload.mediaIds,
				LOGO: [logoIdRef.current],
			};
		}
		dispatch(AddCarAgentListing(_payload));
	};


	const ResetHendler = () => {
		setCarAgentsDAta({});
		setImageLogo({});
	};
	
	const sideBarOpt = [
		{
			icon: 'assets/images/icons/sp-business/manage-business.svg',
			link:'/sp-cars-agents-business',
			label: 'Manage Business'
		},
		{
			icon: 'assets/images/icons/sp-business/manage-service.svg',
			link:'/sp-cars-agents-cars',
			label: 'Manage Service'
		},
		{
			icon: 'assets/images/icons/sp-business/banner.svg',
			link:'/sp-cars-agents-banner',
			label: 'Banner'
		},
		{
			icon: 'assets/images/icons/sp-business/manage-working-hours.svg',
			link:'/sp-car-dealers-working-hours',
			label: 'Manage Working Hours'
		},
	]
	return (
		<div>
			<CarAgentCommonHeader/>

			<div class='main-content-area'>
				<div class='container'>
					<div class='row justify-content-between'>
						
					<Sidebar options={sideBarOpt}/>

						<div class='col-12 col-sm-12 col-md-9 col-lg-9'>
							<h2>Manage Business</h2>

							<form onSubmit={handleSubmit(datasubmit)}>
								<div class='form-group'>
									<label for='g-mb-business-name'>Business Name</label>
									<input
										{...field('carAgentName', {
											required: t('This field is required'),
											minLength: {
												value: 4,
												message: 'Business Name should be minimum  4 character',
											},
											// pattern: {
											// 	value: /^[a-zA-Z0-9](_(?!(\.|_))|\.(?!(_|\.))|[a-zA-Z0-9]){6,18}[a-zA-Z0-9]$/,
											// 	message:
											// 		'username can only use letters,numbers, minimum length is 6 characters',
											// },
										})}
										name='carAgentName'
										value={CarAgentsData.carAgentName}
										type='text'
										className={classNames('form-control', {
											'is-invalid': errors.carAgentName,
										})}
										id='g-mb-business-name'
										placeholder='Business Name'
									/>
									{errors.carAgentName && (
										<p className='invalid-feedback'>
											{errors.carAgentName.message}
										</p>
									)}
								</div>

								<div class='form-group'>
									<label>Business Logo Image</label>
									<div class='row align-items-center '>
										<div class='col-auto'>
											<div class=' row-cols-7'>
												<img
													style={{
														height: '7rem',
														width: '7rem',
														borderRadius: '7rem',
														objectFit: 'cover',
														border: '1px solid #e3e3e3',
														background: '#f7f7f7',
													}}
													class='profile-pic img-fluid '
													// src='assets/images/camera.jpg'
													// src='/Screenshot (4).png'
													src={
														ImageLogo.sImage
															? ImageLogo.sImage
															: 'assets/images/camera.jpg'
													}
													alt=''
												/>
											</div>
										</div>
										<div class='col-auto'>
											<div class='p-image'>
												<label
													class='btn btn-outline-secondary upload-button btn-sm'
													for='files'>
													Upload Logo image
												</label>
												<input
													type='file'
													id='files'
													accept='image/*'
													onChange={handleUploadImage}
													// onChange={imageIds}
													style={{ display: 'none' }}
												/>
											</div>
										</div>
									</div>
								</div>
								{/* <div class='form-group'>
									<label>Business Logo Image</label>
									<div class='row align-items-center'>
										<div class='col-auto'>
											<div class='circle'>
												<img
													class='profile-pic img-fluid'
													src='assets/images/camera.jpg'
													alt=''
												/>
											</div>
										</div>
										<div class='col-auto'>
											<div class='p-image'>
												<a
													class='btn btn-outline-secondary upload-button btn-sm'
													href='javascript:void(0);'
													role='button'>
													Upload Logo image
												</a>
												<input
													class='file-upload'
													type='file'
													accept='image/*'
												/>
											</div>
										</div>
									</div>
								</div> */}

								<div class='form-group'>
									<label for='g-mb-phone-number'>Phone Number</label>
									<div class='row'>
										<div class='col-4'>
											<select
												class='form-control'
												name='mobileNumberCountryCode'
												value={CarAgentsData.mobileNumberCountryCode}
												onChange={handleChange}>
												<option>{t('Country Code')}</option>
												<option>+965</option>
											</select>
										</div>
										<div class='col-8'>
											<input
												{...field('mobileNumber', {
													required: t('This field is required'),
													minLength: {
														value: 10,
														message: 'number must have  minimum 10 digit',
													},
													pattern: {
														value: /\d{10}$/,
														message:
															'please enter a valid 10-digit phone number ',
													},
												})}
												name='mobileNumber'
												value={CarAgentsData.mobileNumber}
												type='tel'
												className={classNames('form-control', {
													'is-invalid': errors.mobileNumber,
												})}
												id='g-mb-phone-number'
												placeholder='Phone Number'
											/>
											{errors.mobileNumber && (
												<p className='invalid-feedback'>
													{errors.mobileNumber.message}
												</p>
											)}
										</div>
									</div>
								</div>

								<div class='form-group'>
									<label for='g-mb-whatsApp-number'>
										{t('WhatsApp Number')} <small>(Optional)</small>
									</label>
									<div class='row'>
										<div class='col-4'>
											<select class='form-control'>
												<option>{t('Country Code')}</option>
												<option>+965</option>
											</select>
										</div>
										<div class='col-8'>
											<input
												{...register('WhatsAppNumber', {
													// required: 'this field is requerd',
													minLength: {
														value: 10,
														message: 'number must have  minimum 10 digit',
													},
													pattern: {
														value: /\d{10}$/,
														message:
															'please enter a valid 10-digit phone number ',
													},
												})}
												name='WhatsAppNumber'
												// value={garageData.mobileNumber}
												onChange={handleChange}
												type='tel'
												className={classNames('form-control', {
													'is-invalid': errors.WhatsAppNumber,
												})}
												id='g-mb-whatsApp-number'
												placeholder='WhatsApp Number'
											/>
											{errors.WhatsAppNumber && (
												<p className='invalid-feedback'>
													{errors.WhatsAppNumber.message}
												</p>
											)}
										</div>
									</div>
								</div>

								<div class='form-group'>
									<label>
										{t('Additional Phone Numbers')} <small>(Optional)</small>
									</label>
									{extraPhones.map((phone, idx) => (
										<div class='row' key={idx} style={{ marginBottom: '8px' }}>
											<div class='col-4'>
												<select
													class='form-control'
													value={phone.countryCode}
													onChange={e =>
														updateExtraPhone(idx, 'countryCode', e.target.value)
													}>
													<option value='+965'>+965</option>
												</select>
											</div>
											<div class='col-7'>
												<input
													type='tel'
													inputMode='numeric'
													class='form-control'
													value={phone.mobileNumber}
													placeholder='Phone Number'
													onChange={e =>
														updateExtraPhone(idx, 'mobileNumber', e.target.value)
													}
												/>
											</div>
											<div class='col-1 px-0'>
												<button
													type='button'
													class='btn btn-outline-danger btn-block'
													title='Remove'
													onClick={() => removeExtraPhone(idx)}>
													&times;
												</button>
											</div>
										</div>
									))}
									<button
										type='button'
										class='btn btn-outline-secondary btn-sm'
										onClick={addExtraPhone}>
										+ Add phone number
									</button>
								</div>

								<div class='form-group'>
									<label for='g-mb-about-company'>
										{t('About the Company')} <small>(Optional)</small>
									</label>
									<textarea
										class='form-control'
										id='g-mb-about-company'
										rows='2'
										name='about'
										value={CarAgentsData.about}
										onChange={handleChange}
										></textarea>
								</div>

								<div class='form-group'>
									<label for='g-mb-location-map'>Select Location on Map</label>
									<input
										type='text'
										class='form-control'
										id='g-mb-location-map'
										placeholder='Select Location on Map'
										name='location'
										value={CarAgentsData.location}
										onChange={handleChange}
									/>
								</div>

								<LogoCropModal
									open={!!cropSrc}
									imageSrc={cropSrc}
									fileName={cropName}
									onCancel={() => setCropSrc(null)}
									onApply={uploadCroppedLogo}
								/>

								<div class='form-group'>
									<label for='g-mb-website'>
										{t('Website')} <small>(Optional)</small>
									</label>
									<input
										name='website'
										value={CarAgentsData.website}
										onChange={handleChange}
										type='text'
										class='form-control'
										id='g-mb-website'
										placeholder='Website'
									/>
								</div>

								{/* <div class='form-group'>
									<h5>Add Social Media Channels</h5>
									<ul
										class='list-inline mb-0 social-media-channel '
										style={{ display: 'flex', flexDirection: 'column' }}>
										<li
											class='list-inline-item mb-2 '
											style={{ display: 'flex' }}>
											<a href='javascript:void(0);'>
												<img
													src='assets/images/service-provider/facebook.png'
													alt=''
												/>
											</a>
											<input
												name='FACEBOOK'
												value={CarAgentsData.FACEBOOK}
												onChange={mediaChange}
												type='text'
												class='form-control    col-10 m-3'
												id='g-mb-website'
												placeholder='facebook'
											/>
										</li>
										<li
											class='list-inline-item mb-2'
											style={{ display: 'flex' }}>
											<a href='javascript:void(0);'>
												<img
													src='assets/images/service-provider/instagram.png'
													alt=''
												/>
											</a>
											<input
												name='INSTAGRAM'
												value={CarAgentsData.INSTAGRAM}
												onChange={mediaChange}
												type='text'
												class='form-control    col-10 m-3'
												id='g-mb-website'
												placeholder='instagram'
											/>
										</li>
										<li
											class='list-inline-item mb-2'
											style={{ display: 'flex' }}>
											<a href='javascript:void(0);'>
												<img
													src='assets/images/service-provider/twitter.png'
													alt=''
												/>
											</a>
											<input
												name='TWITTER'
												value={CarAgentsData.TWITTER}
												onChange={mediaChange}
												type='text'
												class='form-control    col-10 m-3'
												id='g-mb-website'
												placeholder='twitter'
											/>
										</li>
										<li
											class='list-inline-item mb-2'
											style={{ display: 'flex' }}>
											<a href='javascript:void(0);'>
												<img
													src='assets/images/service-provider/youtube.png'
													alt=''
												/>
											</a>
											<input
												name='YOUTUBE'
												value={CarAgentsData.YOUTUBE}
												onChange={mediaChange}
												type='text'
												class='form-control    col-10 m-3'
												id='g-mb-website'
												placeholder='youtube'
											/>
										</li>
										<li
											class='list-inline-item mb-2'
											style={{ display: 'flex' }}>
											<a href='javascript:void(0);'>
												<img
													src='assets/images/service-provider/linkedin.png'
													alt=''
												/>
											</a>
											<input
												name='LINKEDIN'
												value={CarAgentsData.LINKEDIN}
												onChange={mediaChange}
												type='text'
												class='form-control    col-10 m-3'
												id='g-mb-website'
												placeholder='linkedin'
											/>
										</li>
										<li
											class='list-inline-item mb-2'
											style={{ display: 'flex' }}>
											<a href='javascript:void(0);'>
												<img
													src='assets/images/service-provider/snapchat.png'
													alt=''
												/>
											</a>
											<input
												name='SNAPCHAT'
												value={CarAgentsData.SNAPCHAT}
												onChange={mediaChange}
												type='text'
												class='form-control    col-10 m-3'
												id='g-mb-website'
												placeholder='snapchat'
											/>
										</li>	
									</ul>
								</div> */}

								<div class='row'>
									<div class='col-6'>
										<button
											onClick={ResetHendler}
											type='reset'
											class='btn btn-secondary btn-block'
											// href='#'
											// role='button'
										>
											Reset
										</button>
									</div>
									<div class='col-6'>
										<button
											type='submit'
											// to='/sp-cars-agents-business-packages'
											class='btn btn-warning btn-block'
											// href='sp-cars-agents-manage-business-packages.html'
											// role='button'
										>
											Next
										</button>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default CarAgentsBusiness;
